<template>
  <div class="c-app">
    <SideMenu
      :items="routes"
      :show="showMenu"
      @toggle-menu="handleToggleMenu"
    />
    <CWrapper>
      <Header @toggle-menu="handleToggleMenu" />
      <div class="c-body">
        <CAlert
          v-if="homolog"
          color="warning"
          class="text-center mb-0"
        >
          <CIcon
            name="cil-warning"
            class="ml-2 mb-1"
          />
          <b>
            Você está utilizando o ambiente de homologação, quaisquer alterações
            realizadas não afetarão o sistema em produção.
          </b>
        </CAlert>
        <main class="c-main">
          <CContainer fluid>
            <transition name="fade">
              <router-view></router-view>
            </transition>
          </CContainer>
        </main>
      </div>
    </CWrapper>
  </div>
</template>

<script>
import SideMenu from '@/components/ui/SideMenu'
import menuItems from '@/components/ui/SideMenu/menuItems'
import Header from '@/components/layout/Header'

import SettingService from '@/services/settings.service'
import ContactService from '@/services/contact.service'

import { mapGetters } from 'vuex'
import Cookies from 'js-cookie'

export default {
  components: {
    SideMenu,
    Header
  },

  data () {
    return {
      routes: [],
      showMenu: false,
      homolog: '',
      userLogged: {}
    }
  },

  computed: {
    ...mapGetters('auth', {
      user: 'user'
    })
  },

  async created () {
    // 1. Carrega dados do usuário (Prioriza Cookie ou Vuex se disponível)
    const userData = Cookies.getJSON('ow:user')
    this.userLogged = userData?.data?.user || this.user || {}

    // 2. Inicializa as rotas filtradas
    await this.setRoutes()

    // 3. Demais inicializações
    this.listenEventsOnRouteUpdate()
    this.openMenu()
    this.getSettings()
  },

  methods: {
    async setRoutes () {
      const contactBadge = await this.getContactBadges()
      const isRH = this.userLogged.email === 'rh@owinteractive.com'
      this.routes = menuItems.map(group => {
        const newGroup = { ...group }

        newGroup._children = group._children
          .filter(child => {
            if (isRH) {
              const isMainTitle =
                child._name === 'CSidebarNavTitle' &&
                child._children?.includes('OW Interactive')
              const isCarreira = child.name === 'Carreira'
              return isMainTitle || isCarreira
            }

            return true
          })
          .map(child => {
            if (child.to === '/contacts') {
              if (contactBadge && contactBadge.totalUnread) {
                return {
                  ...child,
                  badge: { color: 'danger', text: contactBadge.totalUnread }
                }
              } else {
                const cleanChild = { ...child }
                delete cleanChild.badge
                return cleanChild
              }
            }
            return child
          })

        return newGroup
      })
    },

    async getContactBadges () {
      try {
        const response = await ContactService.getAll({
          pagination: false,
          filter: 'all'
        })
        return response.totals
      } catch (error) {
        return null
      }
    },

    async getSettings () {
      const data = await SettingService.listAll()
      this.homolog = data.environment === 'homolog'
    },

    listenEventsOnRouteUpdate () {
      this.$root.$on('update:routes', () => {
        this.setRoutes()
      })
    },

    openMenu () {
      const handler = () => {
        this.showMenu = window.innerWidth > 992
      }
      window.addEventListener('resize', handler)
      handler()
    },

    handleToggleMenu () {
      this.showMenu = !this.showMenu
    }
  }
}
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
